import { LabeledIconChip } from '@app/core';
import React, { ReactNode } from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Colors, Theme } from '@app/theme';
import { LabeledSection } from './LabeledSection';

const useStyles = createUseStyles((theme: Theme) => ({
  chipContainer: {
    display: 'inline-flex',
    flexDirection: 'row',
    gap: theme.marginBase,
    flexWrap: 'wrap',
  },
  icon: {
    marginRight: theme.marginBase,
    fontSize: theme.iconSize.small,
  },
}));

interface Props {
  label: ReactNode;
  chipColor?: Colors;
  chipsData: Array<{
    label: string;
    icon: string;
  }>;
  children?: React.ReactNode;
}

export const LabeledSectionWithChipsList: React.FC<Props> = ({
  chipsData,
  label,
  chipColor = 'inkSecondary',
  children,
}) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <LabeledSection label={label}>
      <div className={classes.chipContainer}>
        {chipsData.map(({ label, icon }) => (
          <LabeledIconChip
            labelColor={chipColor}
            key={label}
            chipIcon={icon}
            chipLabel={label}
          />
        ))}
        {children}
      </div>
    </LabeledSection>
  );
};
